module.exports = __webpack_public_path__ + "media/images/emp/hex-bg-6633a16d942ac9d7e1a4ad258417fc8d.png";